var map = {
	"./admin.png": "e2fa",
	"./attention-1.png": "d3bf",
	"./attention.png": "5d1f",
	"./avater.png": "ce91",
	"./cover.png": "7c22",
	"./doctor.png": "4b3c",
	"./doctorDetail.png": "1023",
	"./play.png": "e9d1",
	"./trophy.png": "9fa1",
	"./video.png": "2b26",
	"./vote.png": "ca15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "765f";